/* JHB Luxe — progressive enhancement for homepage + product page.
   Add-to-cart deliberately reuses Belliza's own [data-btn-addtocart] handler
   (cart drawer, redirects, errors). Without JS, forms post to /cart/add. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var v = cents / 100;
    return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.jl-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHero() {
    document.querySelectorAll('.jl-hero').forEach(function (hero) {
      var img = hero.querySelector('.jl-hero__media img');
      var ready = function () { requestAnimationFrame(function () { hero.classList.add('is-ready'); }); };
      if (!img || img.complete) ready(); else { img.addEventListener('load', ready); img.addEventListener('error', ready); }
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-jl-tabs]').forEach(function (wrap) {
      if (wrap.__jl) return; wrap.__jl = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () { select(idx); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (idx + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n); tabs[n].focus();
          }
        });
      });
      function select(i) {
        tabs.forEach(function (t, j) {
          var on = i === j, panel = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
          if (panel) {
            panel.hidden = !on;
            if (on) { panel.classList.remove('is-entering'); void panel.offsetWidth; panel.classList.add('is-entering'); }
          }
        });
      }
    });
  }

  function initPDP(root) {
    if (root.__jl) return; root.__jl = true;
    var dataEl = root.querySelector('[data-jl-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('[data-jl-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-jl-add]');
    var priceNow = root.querySelectorAll('[data-jl-price]');
    var priceWas = root.querySelector('[data-jl-compare]');
    var stock = root.querySelector('[data-jl-stock]');
    var offer = root.querySelector('[data-jl-offer]');
    var freeAt = parseInt(root.getAttribute('data-free-at') || '0', 10);
    var showCompare = root.getAttribute('data-show-compare') === 'true';

    var track = root.querySelector('.jl-gallery__track');
    var slides = track ? track.querySelectorAll('.jl-gallery__slide') : [];
    var thumbs = root.querySelectorAll('.jl-gallery__thumbs button');
    var dots = root.querySelectorAll('.jl-gallery__dots button');
    var count = root.querySelector('.jl-gallery__count');
    var current = 0;
    function go(i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j); });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', i === j); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) mark(i);
        });
      }, { passive: true });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      var prev = root.querySelector('[data-jl-prev]'), next = root.querySelector('[data-jl-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });

      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      slides.forEach(function (s, j) {
        var img = s.querySelector('img');
        if (!img) return;
        if (fine) {
          s.addEventListener('mousemove', function (e) {
            var r = s.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          });
          s.addEventListener('mouseenter', function () { s.classList.add('is-zoom'); });
          s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
        }
        s.addEventListener('click', function () { openLightbox(j); });
      });
    }

    var lb = root.querySelector('.jl-lightbox');
    if (lb) document.body.appendChild(lb);
    function openLightbox(i) {
      if (!lb) return;
      lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      var t = lb.querySelector('.jl-lightbox__track');
      t.scrollLeft = t.clientWidth * i;
      lb.querySelector('.jl-lightbox__close').focus();
    }
    function closeLightbox() { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    if (lb) {
      lb.querySelector('.jl-lightbox__close').addEventListener('click', closeLightbox);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLightbox(); });
    }

    root.querySelectorAll('[data-jl-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var v = (parseInt(input.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1);
        input.value = Math.max(1, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    function selected() {
      var vals = [];
      root.querySelectorAll('.jl-opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); vals.push(c ? c.value : null);
        var lbl = fs.querySelector('legend span'); if (lbl && c) lbl.textContent = c.value;
      });
      return vals;
    }
    function findVariant(vals) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
    }
    var stickyBar = document.querySelector('.jl-sticky');
    var sAdd = stickyBar && stickyBar.querySelector('[data-jl-sticky-add]');
    function update(v) {
      if (!v) {
        [addBtn, sAdd].forEach(function (b) { if (b) { b.classList.add('is-disabled', 'is-soldout'); b.textContent = 'Unavailable'; } });
        return;
      }
      if (idInput) idInput.value = v.id;
      priceNow.forEach(function (p) { p.textContent = money(v.price); });
      var disc = showCompare && v.compare_at_price > v.price;
      root.querySelectorAll('[data-jl-compare]').forEach(function (el) { el.hidden = !disc; if (disc) el.textContent = money(v.compare_at_price); });
      var save = root.querySelector('[data-jl-save]');
      if (save) { save.hidden = !disc; if (disc) save.textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; }
      var ys = root.querySelector('[data-jl-yousave]');
      if (ys && disc) ys.textContent = 'You save ' + money(v.compare_at_price - v.price);
      [addBtn, sAdd].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-disabled', !v.available);
        b.classList.toggle('is-soldout', !v.available);
        b.textContent = v.available ? (b.getAttribute('data-label') || 'Add to bag') : 'Sold out';
      });
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        stock.classList.toggle('is-low', v.available && v.low);
        stock.querySelector('span').textContent = !v.available ? 'Currently sold out' : (v.low ? 'Only a few left' : 'In stock, ready to ship');
      }
      if (offer && freeAt) {
        var gap = freeAt - v.price;
        offer.innerHTML = gap > 0
          ? 'Add <strong>' + money(gap) + '</strong> more for <strong>free delivery</strong>. <a href="#jl-related">Add a piece</a>'
          : '<strong>Free delivery</strong> on this piece.';
      }
      if (v.media_index != null && v.media_index > -1) go(v.media_index);
      if (history.replaceState && variants.length > 1) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      root.querySelectorAll('.jl-opt').forEach(function (fs, oi) {
        var vals = selected();
        fs.querySelectorAll('.jl-opt__val').forEach(function (wrap) {
          var test = vals.slice(); test[oi] = wrap.querySelector('input').value;
          var m = findVariant(test);
          wrap.classList.toggle('is-unavailable', !m || !m.available);
        });
      });
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('.jl-opt')) update(findVariant(selected()));
    });
    if (variants.length > 1) update(findVariant(selected()));

    if (stickyBar && addBtn) {
      document.body.appendChild(stickyBar);
      document.body.classList.add('jl-has-sticky');
      var ticking = false;
      var check = function () {
        ticking = false;
        var r = addBtn.getBoundingClientRect();
        var past = r.bottom < 0 || (window.innerWidth < 990 && r.top > window.innerHeight);
        stickyBar.classList.toggle('is-on', past);
        document.body.classList.toggle('jl-sticky-on', past);
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      if (sAdd) sAdd.addEventListener('click', function (e) {
        e.preventDefault();
        if (variants.length > 1 && !findVariant(selected())) { root.scrollIntoView({ behavior: 'smooth' }); return; }
        addBtn.click();
      });
    }

    var eta = root.querySelector('[data-jl-eta]');
    if (eta) {
      var nums = (eta.getAttribute('data-jl-eta') || '7-10').match(/\d+/g) || [7, 10];
      var add = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var f = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var a = add(+nums[0]), b = add(+(nums[1] || nums[0]));
      var out = eta.querySelector('[data-jl-eta-out]');
      if (out) out.textContent = f(a) + ' – ' + f(b);
    }

    var share = root.querySelector('[data-jl-share]');
    if (share) share.addEventListener('click', function () {
      var data = { title: document.title, url: location.href.split('?')[0] };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { share.textContent = 'Link copied'; setTimeout(function () { share.textContent = 'Copy link'; }, 2000); }); }
    });
  }


  /* ---------- Hero slider (native scroll-snap, no library) ---------- */
  function initSlider(root) {
    if (root.__jl) return; root.__jl = true;
    var track = root.querySelector('[data-jl-sl-track]');
    if (!track) return;
    var slides = track.children, n = slides.length;
    var dots = root.querySelectorAll('[data-jl-sl-dot]');
    var cta = root.querySelector('[data-jl-sl-cta]');
    var playBtn = root.querySelector('[data-jl-sl-play]');
    var cur = 0, timer = null, userPaused = false, hovering = false, visible = true;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 7000;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && n > 1;

    function mark(i) {
      if (i === cur && root.__marked) return;
      cur = i; root.__marked = true;
      for (var j = 0; j < n; j++) {
        var on = j === i;
        if (on) slides[j].removeAttribute('aria-hidden'); else slides[j].setAttribute('aria-hidden', 'true');
        var a = slides[j].querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
      }
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (root.__marked2 && slides[i]) { track.classList.add('is-sized'); track.style.height = slides[i].offsetHeight + 'px'; }
      root.__marked2 = true;
      if (cta && slides[i]) {
        var l = slides[i].getAttribute('data-cta-label'), u = slides[i].getAttribute('data-cta-url');
        if (l) cta.textContent = l; if (u) cta.setAttribute('href', u);
      }
    }
    function go(i, smooth) {
      i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur) mark(i); });
    }, { passive: true });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-jl-sl-prev')) { go(cur - 1); stopFor(); }
      else if (t.hasAttribute('data-jl-sl-next')) { go(cur + 1); stopFor(); }
      else if (t.hasAttribute('data-jl-sl-dot')) { go(+t.getAttribute('data-jl-sl-dot')); stopFor(); }
      else if (t === playBtn) { userPaused = !userPaused; playBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false'); playBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow'); sync(); }
    });
    root.querySelector('.jl-sl__viewport').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(cur + 1); stopFor(); }
      else if (e.key === 'ArrowLeft') { go(cur - 1); stopFor(); }
    });
    function sync() {
      clearInterval(timer); timer = null;
      if (auto && !userPaused && !hovering && visible && !document.hidden) timer = setInterval(function () { go(cur + 1); }, speed);
    }
    function stopFor() { if (auto) { userPaused = true; if (playBtn) { playBtn.setAttribute('aria-pressed', 'true'); playBtn.setAttribute('aria-label', 'Play slideshow'); } sync(); } }
    if (!auto && playBtn) playBtn.hidden = true;
    root.addEventListener('mouseenter', function () { hovering = true; sync(); });
    root.addEventListener('mouseleave', function () { hovering = false; sync(); });
    root.addEventListener('focusin', function () { hovering = true; sync(); });
    root.addEventListener('focusout', function () { hovering = false; sync(); });
    track.addEventListener('touchstart', function () { stopFor(); }, { passive: true });
    document.addEventListener('visibilitychange', sync);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; document.body.classList.toggle('jl-hero-in-view', visible); sync(); }).observe(root);
    window.addEventListener('resize', function () { if (track.classList.contains('is-sized') && slides[cur]) track.style.height = slides[cur].offsetHeight + 'px'; track.scrollLeft = cur * track.clientWidth; }, { passive: true });
    /* After the page has loaded, fetch the other slides so autoplay never shows an empty frame */
    var warm = function () { root.querySelectorAll('.jl-sl__img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); };
    if (document.readyState === 'complete') setTimeout(warm, 1500); else window.addEventListener('load', function () { setTimeout(warm, 1500); });
    mark(0); sync();
  }

  function init() {
    document.documentElement.classList.add('js');
    initHero(); initReveal(); initTabs();
    document.querySelectorAll('[data-jl-pdp]').forEach(initPDP);
    document.querySelectorAll('[data-jl-slider]').forEach(initSlider);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initTabs(); initHero(); e.target.querySelectorAll('[data-jl-pdp]').forEach(initPDP); e.target.querySelectorAll('[data-jl-slider]').forEach(initSlider); });
})();
